import ImageOverlay from './Components/ImageOverlay';
import VideoOverlay from './Components/VideoOverlay';
import type { IImageOverlay, IVideoOverlay } from './MediaOverlay.types';

type MediaOverlayProps = IVideoOverlay | IImageOverlay;

const isVideoOverlay = (
  overlayProps: MediaOverlayProps
): overlayProps is IVideoOverlay => {
  return 'videos' in overlayProps && !!overlayProps.videos.fallback;
};

export default function MediaOverlay(props: MediaOverlayProps) {
  if (isVideoOverlay(props)) {
    return <VideoOverlay {...props}>{props.children}</VideoOverlay>;
  } else {
    return <ImageOverlay {...props}>{props.children}</ImageOverlay>;
  }
}
